import React, { useState } from 'react';

// --- MOCK PARTNER DATA ---
const PARTNER_DATA = [
  {
    id: 'comp-1',
    name: 'Apex Logistics Inc.',
    code: 'APX',
    industry: 'Supply Chain & Freight',
    logoBg: 'linear-gradient(135deg, #FF4B4B, #FF8533)',
    licenses: [
      { state: 'California', code: 'CA', licenseNo: 'CA-LOG-88391', expiry: '2026-08-15' }, // < 1 month
      { state: 'Texas', code: 'TX', licenseNo: 'TX-LOG-44120', expiry: '2025-11-20' },     // Expired
      { state: 'Florida', code: 'FL', licenseNo: 'FL-LOG-99210', expiry: '2027-05-10' },   // Active
      { state: 'New York', code: 'NY', licenseNo: 'NY-LOG-10293', expiry: '2026-08-25' },  // < 1 month
      { state: 'Illinois', code: 'IL', licenseNo: 'IL-LOG-55102', expiry: '2027-01-30' },  // Active
    ]
  },
  {
    id: 'comp-2',
    name: 'BioPharma Health US',
    code: 'BPH',
    industry: 'Pharmaceuticals & Med',
    logoBg: 'linear-gradient(135deg, #3B82F6, #06B6D4)',
    licenses: [
      { state: 'New York', code: 'NY', licenseNo: 'NY-MED-77182', expiry: '2026-08-10' },  // < 1 month
      { state: 'Ohio', code: 'OH', licenseNo: 'OH-MED-33291', expiry: '2024-12-01' },      // Expired
      { state: 'Georgia', code: 'GA', licenseNo: 'GA-MED-90812', expiry: '2027-09-15' },   // Active
      { state: 'Washington', code: 'WA', licenseNo: 'WA-MED-12399', expiry: '2026-08-05' },// < 1 month
    ]
  },
  {
    id: 'comp-3',
    name: 'Nexus Tech Services',
    code: 'NXT',
    industry: 'IT Infrastructure',
    logoBg: 'linear-gradient(135deg, #10B981, #059669)',
    licenses: [
      { state: 'Washington', code: 'WA', licenseNo: 'WA-TEC-90211', expiry: '2028-02-14' },// Active
      { state: 'Colorado', code: 'CO', licenseNo: 'CO-TEC-44812', expiry: '2026-08-18' },  // < 1 month
      { state: 'Arizona', code: 'AZ', licenseNo: 'AZ-TEC-66319', expiry: '2026-01-10' },   // Expired
      { state: 'Virginia', code: 'VA', licenseNo: 'VA-TEC-88120', expiry: '2027-11-01' },   // Active
    ]
  },
  {
    id: 'comp-4',
    name: 'Vanguard Energy Corp',
    code: 'VEC',
    industry: 'Renewables & Power',
    logoBg: 'linear-gradient(135deg, #F59E0B, #D97706)',
    licenses: [
      { state: 'Texas', code: 'TX', licenseNo: 'TX-NRG-11029', expiry: '2026-08-02' },     // < 1 month
      { state: 'California', code: 'CA', licenseNo: 'CA-NRG-77401', expiry: '2025-06-30' },// Expired
      { state: 'Nevada', code: 'NV', licenseNo: 'NV-NRG-33921', expiry: '2027-04-12' },    // Active
      { state: 'Oregon', code: 'OR', licenseNo: 'OR-NRG-50012', expiry: '2026-08-28' },    // < 1 month
    ]
  }
];

// --- HELPER FUNCTION: EXPIRATION CALCULATION ---
const getLicenseStatus = (expiryDateStr) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const expiry = new Date(expiryDateStr);
  const timeDiff = expiry.getTime() - today.getTime();
  const daysDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));

  if (daysDiff < 0) {
    return { status: 'EXPIRED', days: Math.abs(daysDiff), label: 'ALREADY EXPIRED' };
  } else if (daysDiff <= 30) {
    return { status: 'WARNING', days: daysDiff, label: `${daysDiff} DAYS REMAINING` };
  } else {
    return { status: 'ACTIVE', days: daysDiff, label: 'ACTIVE & VALID' };
  }
};

export default function App() {
  // Authentication State
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [loginError, setLoginError] = useState('');

  // Dashboard Filters State
  const [selectedCompanyId, setSelectedCompanyId] = useState('ALL');
  const [statusFilter, setStatusFilter] = useState('ALL');
  const [searchTerm, setSearchTerm] = useState('');

  // Handle Login
  const handleLogin = (e) => {
    e.preventDefault();
    if (credentials.username.trim() !== '' && credentials.password.trim() !== '') {
      setIsLoggedIn(true);
      setLoginError('');
    } else {
      setLoginError('Please enter any User ID and Password.');
    }
  };

  const filteredCompanies = selectedCompanyId === 'ALL'
    ? PARTNER_DATA
    : PARTNER_DATA.filter((c) => c.id === selectedCompanyId);

  return (
    <div style={styles.container}>
      {/* KEYFRAME ANIMATIONS & MOBILE RESPONSIVE MEDIA QUERIES */}
      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(14px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes pulseRed {
          0% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0.5); }
          70% { box-shadow: 0 0 0 10px rgba(239, 68, 68, 0); }
          100% { box-shadow: 0 0 0 0 rgba(239, 68, 68, 0); }
        }
        @keyframes borderGlow {
          0% { border-color: rgba(239, 68, 68, 0.8); }
          50% { border-color: rgba(248, 113, 113, 1); }
          100% { border-color: rgba(239, 68, 68, 0.8); }
        }

        /* --- MOBILE RESPONSIVE OVERRIDES --- */
        @media (max-width: 768px) {
          .nav-bar {
            padding: 14px 18px !important;
            flex-direction: column !important;
            align-items: flex-start !important;
            gap: 12px !important;
          }
          .user-box {
            width: 100% !important;
            justify-content: space-between !important;
          }
          .controls-bar {
            padding: 14px 18px !important;
            flex-direction: column !important;
            align-items: stretch !important;
            gap: 12px !important;
          }
          .search-input {
            width: 100% !important;
          }
          .filter-group {
            flex-wrap: wrap !important;
            width: 100% !important;
            justify-content: flex-start !important;
          }
          .filter-chips {
            display: flex !important;
            width: 100% !important;
            overflow-x: auto !important;
            padding-bottom: 4px !important;
          }
          .main-content {
            padding: 16px !important;
            gap: 20px !important;
          }
          .company-card {
            padding: 16px !important;
          }
          .license-grid {
            grid-template-columns: 1fr !important;
          }
          .login-card {
            padding: 24px 20px !important;
          }
        }
      `}</style>

      {!isLoggedIn ? (
        /* --- DARK THEME LOGIN SCREEN --- */
        <div style={styles.loginWrapper}>
          <div className="login-card" style={{ ...styles.loginCard, animation: 'fadeIn 0.5s ease-out' }}>
            <div style={styles.loginHeader}>
              <div style={styles.logoIcon}>🛡️</div>
              <h2 style={styles.loginTitle}>Partner License Portal</h2>
              <p style={styles.loginSubtitle}>USA State Compliance & License Tracker</p>
            </div>

            <form onSubmit={handleLogin} style={styles.form}>
              {loginError && <div style={styles.errorBox}>{loginError}</div>}

              <div style={styles.inputGroup}>
                <label style={styles.label}>User ID / Email</label>
                <input
                  type="text"
                  placeholder="admin@partnerportal.com"
                  value={credentials.username}
                  onChange={(e) => setCredentials({ ...credentials, username: e.target.value })}
                  style={styles.input}
                  required
                />
              </div>

              <div style={styles.inputGroup}>
                <label style={styles.label}>Password</label>
                <input
                  type="password"
                  placeholder="••••••••••••"
                  value={credentials.password}
                  onChange={(e) => setCredentials({ ...credentials, password: e.target.value })}
                  style={styles.input}
                  required
                />
              </div>

              <button type="submit" style={styles.loginButton}>
                Sign In to Portal →
              </button>
            </form>

            <div style={styles.demoNote}>
              💡 Enter any ID & Password to test the portal.
            </div>
          </div>
        </div>
      ) : (
        /* --- DARK THEME DASHBOARD --- */
        <div style={styles.dashboardLayout}>
          {/* TOP NAVBAR */}
          <header className="nav-bar" style={styles.navbar}>
            <div style={styles.navBrand}>
              <span style={styles.brandBadge}>USA COMPLIANCE SYSTEM</span>
              <h1 style={styles.navTitle}>Partner State Licenses</h1>
            </div>
            <div className="user-box" style={styles.userInfo}>
              <span style={styles.userText}>User: <strong>{credentials.username}</strong></span>
              <button style={styles.logoutBtn} onClick={() => setIsLoggedIn(false)}>
                Logout
              </button>
            </div>
          </header>

          {/* DASHBOARD FILTERS */}
          <div className="controls-bar" style={styles.controlsBar}>
            <input
              type="text"
              className="search-input"
              placeholder="🔍 Search state name or license #..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              style={styles.searchInput}
            />

            <div className="filter-group" style={styles.filterGroup}>
              <label style={styles.filterLabel}>Company:</label>
              <select
                value={selectedCompanyId}
                onChange={(e) => setSelectedCompanyId(e.target.value)}
                style={styles.selectInput}
              >
                <option value="ALL">All Partners (4)</option>
                {PARTNER_DATA.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-group filter-chips" style={styles.filterGroup}>
              <button
                onClick={() => setStatusFilter('ALL')}
                style={{
                  ...styles.chipBtn,
                  ...(statusFilter === 'ALL' ? styles.chipActive : {})
                }}
              >
                All
              </button>
              <button
                onClick={() => setStatusFilter('WARNING')}
                style={{
                  ...styles.chipBtn,
                  ...(statusFilter === 'WARNING' ? styles.chipWarningActive : {})
                }}
              >
                ⚠️ Expiring &lt; 30 Days
              </button>
              <button
                onClick={() => setStatusFilter('EXPIRED')}
                style={{
                  ...styles.chipBtn,
                  ...(statusFilter === 'EXPIRED' ? styles.chipExpiredActive : {})
                }}
              >
                🚨 Already Expired
              </button>
            </div>
          </div>

          {/* MAIN CONTENT GRID */}
          <main className="main-content" style={styles.mainGrid}>
            {filteredCompanies.map((company) => {
              const companyLicenses = company.licenses.filter((lic) => {
                const statusInfo = getLicenseStatus(lic.expiry);
                const matchesSearch =
                  lic.state.toLowerCase().includes(searchTerm.toLowerCase()) ||
                  lic.licenseNo.toLowerCase().includes(searchTerm.toLowerCase());

                let matchesStatus = true;
                if (statusFilter === 'WARNING') matchesStatus = statusInfo.status === 'WARNING';
                if (statusFilter === 'EXPIRED') matchesStatus = statusInfo.status === 'EXPIRED';

                return matchesSearch && matchesStatus;
              });

              if (companyLicenses.length === 0) return null;

              return (
                <div key={company.id} className="company-card" style={styles.companyCard}>
                  {/* Company Header */}
                  <div style={styles.companyHeader}>
                    <div style={{ ...styles.companyLogo, background: company.logoBg }}>
                      {company.code}
                    </div>
                    <div>
                      <h3 style={styles.companyName}>{company.name}</h3>
                      <span style={styles.companyTag}>{company.industry}</span>
                    </div>
                  </div>

                  {/* License Cards Grid */}
                  <div className="license-grid" style={styles.licenseGrid}>
                    {companyLicenses.map((lic, index) => {
                      const statusInfo = getLicenseStatus(lic.expiry);

                      // Dynamic Dark Theme Status Styles
                      let cardBorder = '1px solid rgba(255, 255, 255, 0.1)';
                      let badgeBg = 'rgba(16, 185, 129, 0.2)';
                      let badgeText = '#34D399';
                      let dateColor = '#94A3B8';
                      let animationStyle = {};

                      if (statusInfo.status === 'EXPIRED') {
                        cardBorder = '1.5px solid #EF4444';
                        badgeBg = 'rgba(239, 68, 68, 0.25)';
                        badgeText = '#FCA5A5';
                        dateColor = '#EF4444';
                        animationStyle = { animation: 'pulseRed 2s infinite' };
                      } else if (statusInfo.status === 'WARNING') {
                        cardBorder = '1.5px solid #F59E0B';
                        badgeBg = 'rgba(245, 158, 11, 0.25)';
                        badgeText = '#FDE68A';
                        dateColor = '#F59E0B';
                        animationStyle = { animation: 'borderGlow 2.5s infinite' };
                      }

                      return (
                        <div
                          key={index}
                          style={{
                            ...styles.licenseCard,
                            border: cardBorder,
                            ...animationStyle
                          }}
                        >
                          {/* Alert Top Banner for Expired Items */}
                          {statusInfo.status === 'EXPIRED' && (
                            <div style={styles.alertBanner}>
                              🚨 ALERT: LICENSE EXPIRED
                            </div>
                          )}

                          <div style={styles.licenseHeaderRow}>
                            <span style={styles.stateName}>{lic.state}</span>
                            <span
                              style={{
                                ...styles.statusBadge,
                                backgroundColor: badgeBg,
                                color: badgeText
                              }}
                            >
                              {statusInfo.label}
                            </span>
                          </div>

                          <div style={styles.licenseDetailRow}>
                            <span style={styles.detailLabel}>License Number:</span>
                            <code style={styles.licenseCode}>{lic.licenseNo}</code>
                          </div>

                          <div style={styles.licenseDetailRow}>
                            <span style={styles.detailLabel}>Expiration Date:</span>
                            <strong style={{ ...styles.dateValue, color: dateColor }}>
                              {lic.expiry}
                            </strong>
                          </div>

                          {/* Red/Amber Alert Text for < 30 Days Remaining */}
                          {statusInfo.status === 'WARNING' && (
                            <div style={styles.warningAlertText}>
                              ⚠️ Urgent: Under 1 month time remaining!
                            </div>
                          )}
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </main>
        </div>
      )}
    </div>
  );
}

// --- DARK THEME INLINE STYLES ---
const styles = {
  container: {
    minHeight: '100vh',
    backgroundColor: '#090D16', // Deep dark backdrop
    color: '#F1F5F9',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, sans-serif',
    display: 'flex',
    flexDirection: 'column'
  },

  /* LOGIN STYLES */
  loginWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '100vh',
    padding: '20px',
    background: 'radial-gradient(circle at center, #131C2E 0%, #090D16 100%)'
  },
  loginCard: {
    width: '100%',
    maxWidth: '410px',
    backgroundColor: 'rgba(19, 28, 46, 0.85)',
    backdropFilter: 'blur(16px)',
    borderRadius: '18px',
    padding: '36px 30px',
    border: '1px solid rgba(255, 255, 255, 0.1)',
    boxShadow: '0 20px 40px -15px rgba(0, 0, 0, 0.7)'
  },
  loginHeader: {
    textAlign: 'center',
    marginBottom: '26px'
  },
  logoIcon: {
    fontSize: '40px',
    marginBottom: '8px'
  },
  loginTitle: {
    fontSize: '22px',
    fontWeight: '700',
    margin: '0 0 6px 0',
    color: '#F8FAFC'
  },
  loginSubtitle: {
    fontSize: '13px',
    color: '#94A3B8',
    margin: 0
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '6px'
  },
  label: {
    fontSize: '12px',
    fontWeight: '600',
    color: '#CBD5E1',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  input: {
    padding: '12px 14px',
    borderRadius: '8px',
    border: '1px solid #2A364F',
    backgroundColor: '#0D1424',
    color: '#FFFFFF',
    fontSize: '14px',
    outline: 'none'
  },
  loginButton: {
    marginTop: '10px',
    padding: '14px',
    borderRadius: '8px',
    border: 'none',
    background: 'linear-gradient(135deg, #6366F1, #4F46E5)',
    color: '#FFFFFF',
    fontWeight: '700',
    cursor: 'pointer',
    fontSize: '15px',
    boxShadow: '0 4px 14px rgba(99, 102, 241, 0.4)'
  },
  errorBox: {
    backgroundColor: 'rgba(239, 68, 68, 0.2)',
    border: '1px solid #EF4444',
    color: '#FCA5A5',
    padding: '10px',
    borderRadius: '6px',
    fontSize: '13px'
  },
  demoNote: {
    marginTop: '20px',
    textAlign: 'center',
    fontSize: '12px',
    color: '#64748B'
  },

  /* DASHBOARD STYLES */
  dashboardLayout: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column'
  },
  navbar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 32px',
    backgroundColor: '#131C2E',
    borderBottom: '1px solid rgba(255, 255, 255, 0.08)'
  },
  navBrand: {
    display: 'flex',
    flexDirection: 'column',
    gap: '2px'
  },
  brandBadge: {
    fontSize: '10px',
    fontWeight: '800',
    color: '#818CF8',
    letterSpacing: '1px'
  },
  navTitle: {
    fontSize: '18px',
    fontWeight: '700',
    color: '#F8FAFC',
    margin: 0
  },
  userInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px'
  },
  userText: {
    fontSize: '13px',
    color: '#94A3B8'
  },
  logoutBtn: {
    backgroundColor: '#1E293B',
    color: '#F1F5F9',
    border: '1px solid #334155',
    padding: '8px 14px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontWeight: '600',
    fontSize: '12px'
  },

  /* CONTROLS BAR */
  controlsBar: {
    display: 'flex',
    gap: '16px',
    padding: '18px 32px',
    backgroundColor: '#0D1424',
    alignItems: 'center',
    borderBottom: '1px solid rgba(255, 255, 255, 0.05)',
    flexWrap: 'wrap'
  },
  searchInput: {
    flex: 1,
    minWidth: '220px',
    padding: '10px 16px',
    borderRadius: '8px',
    border: '1px solid #2A364F',
    backgroundColor: '#131C2E',
    color: '#FFFFFF',
    fontSize: '14px',
    outline: 'none'
  },
  filterGroup: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px'
  },
  filterLabel: {
    fontSize: '13px',
    color: '#94A3B8',
    fontWeight: '600'
  },
  selectInput: {
    padding: '10px 14px',
    borderRadius: '8px',
    border: '1px solid #2A364F',
    backgroundColor: '#131C2E',
    color: '#FFFFFF',
    fontSize: '13px',
    outline: 'none'
  },
  chipBtn: {
    padding: '8px 12px',
    borderRadius: '20px',
    border: '1px solid #2A364F',
    backgroundColor: '#131C2E',
    color: '#94A3B8',
    cursor: 'pointer',
    fontSize: '12px',
    fontWeight: '600',
    whiteSpace: 'nowrap'
  },
  chipActive: {
    backgroundColor: '#38BDF8',
    color: '#090D16',
    border: '1px solid #38BDF8'
  },
  chipWarningActive: {
    backgroundColor: '#F59E0B',
    color: '#090D16',
    border: '1px solid #F59E0B'
  },
  chipExpiredActive: {
    backgroundColor: '#EF4444',
    color: '#FFFFFF',
    border: '1px solid #EF4444'
  },

  /* MAIN CONTENT */
  mainGrid: {
    padding: '24px 32px',
    display: 'flex',
    flexDirection: 'column',
    gap: '24px'
  },
  companyCard: {
    backgroundColor: '#131C2E',
    borderRadius: '16px',
    padding: '22px',
    border: '1px solid rgba(255, 255, 255, 0.08)'
  },
  companyHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: '14px',
    marginBottom: '20px'
  },
  companyLogo: {
    width: '44px',
    height: '44px',
    borderRadius: '10px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: '800',
    fontSize: '14px',
    color: '#FFFFFF'
  },
  companyName: {
    margin: '0 0 2px 0',
    fontSize: '18px',
    fontWeight: '700',
    color: '#F8FAFC'
  },
  companyTag: {
    fontSize: '12px',
    color: '#64748B',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },

  /* LICENSE GRID */
  licenseGrid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(270px, 1fr))',
    gap: '16px'
  },
  licenseCard: {
    backgroundColor: '#0D1424',
    borderRadius: '12px',
    padding: '16px',
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px'
  },
  alertBanner: {
    backgroundColor: '#EF4444',
    color: '#FFFFFF',
    fontSize: '10px',
    fontWeight: '800',
    textAlign: 'center',
    padding: '4px',
    margin: '-16px -16px 6px -16px',
    letterSpacing: '0.5px'
  },
  licenseHeaderRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  stateName: {
    fontSize: '15px',
    fontWeight: '700',
    color: '#F8FAFC'
  },
  statusBadge: {
    fontSize: '10px',
    fontWeight: '800',
    padding: '4px 8px',
    borderRadius: '12px',
    letterSpacing: '0.5px'
  },
  licenseDetailRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontSize: '13px'
  },
  detailLabel: {
    color: '#64748B',
    fontSize: '12px'
  },
  licenseCode: {
    backgroundColor: '#1E293B',
    padding: '2px 6px',
    borderRadius: '4px',
    color: '#38BDF8',
    fontFamily: 'monospace',
    fontSize: '12px'
  },
  dateValue: {
    fontSize: '13px'
  },
  warningAlertText: {
    fontSize: '11px',
    color: '#F59E0B',
    fontWeight: '600',
    marginTop: '2px'
  }
};